import React from 'react';
import { cn } from "@/lib/utils"
import './shiny-text.css';

interface ShinyTextProps {
  children: React.ReactNode;
  className?: string;
}

export function ShinyText({ children, className }: ShinyTextProps) {
  return (
    <span className={cn("shiny-text", className)}>
      {children}
    </span>
  );
} 